//  Name: editable-name
export default {
  props: {
    value: {}
  },
  data () {
    return {
      edit: false,
      user: Object.assign({}, this.value)
    }
  },
  methods: {
    setEdit () {
      this.edit = true
      this.$set(this, 'user', Object.assign({}, this.value))
    },
    saveEdit () {
      this.edit = false
      this.user.name = this.user.first_name + ' ' + this.user.last_name
      this.$emit('input', Object.assign({}, this.user))
    },
    cancelEdit () {
      this.edit = false
      this.$set(this, 'user', Object.assign({}, this.value))
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/editable-name/script.js